import { FormFieldV2 as FormField } from '@/components/custom/erp';
import { formatRoundedNumber } from '@/lib/formatUtils';
import { Label } from '@/components/ui/label';

interface BottomBarProps {
  tong_tien?: number;
  tong_thue?: number;
  tong_phi?: number;
  tong_thanh_toan?: number;
}

export function BottomBar({ tong_tien = 0, tong_thue = 0, tong_phi = 0, tong_thanh_toan = 0 }: BottomBarProps) {
  return (
    <div className='h-[88px] max-h-[88px] min-h-[88px] w-full overflow-x-auto overflow-y-hidden bg-white px-4 py-2'>
      <div className='grid min-w-[980px] grid-cols-[minmax(320px,420px)_1fr_minmax(380px,460px)] gap-6'>
        <div className='flex flex-col gap-1'>
          <div className='flex items-center gap-2'>
            <Label className='w-32 font-medium'>Tổng tiền</Label>
            <FormField
              name='t_tien_nt'
              type='text'
              disabled={true}
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(tong_tien)}
            />
          </div>
          <div className='flex items-center gap-2'>
            <Label className='w-32 font-medium'>Tổng thuế</Label>
            <FormField
              name='t_thue_nt'
              type='text'
              disabled={true}
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(tong_thue)}
            />
          </div>
        </div>

        <div />

        <div className='flex flex-col gap-1'>
          <div className='flex items-center gap-2'>
            <Label className='w-40 font-medium'>Tổng phí ngân hàng</Label>
            <FormField
              name='t_cp_nt'
              type='text'
              disabled={true}
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(tong_phi)}
            />
          </div>
          <div className='flex items-center gap-2'>
            <Label className='w-40 font-medium'>Tổng thanh toán</Label>
            <FormField
              name='t_tt_nt'
              type='text'
              disabled={true}
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(tong_thanh_toan)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
